<div class="flex gap-3 text-white">
  <mat-icon fontSet="material-symbols-outlined">{{ data.type }}</mat-icon>
  <p class="pr-1 font-inter text-sm/6 font-medium">{{ data.text }}</p>
</div>
